import React from 'react'

interface MoreBtnProps {
  color: string;
  className: string;
  onClickFunc: () => void;
}

const MoreBtn: React.FC<MoreBtnProps> = ({color, className, onClickFunc}) => {
  return (
    <button className={className} onClick={onClickFunc}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          /*
          width="40"
          height="40"
          */
          viewBox="0 0 1000 1000"
        >
          <desc>Created with Fabric.js 3.5.0</desc>
          <rect x="0" y="0" width="40" height="40" fill="none" />
          <g transform="matrix(36.5649 0 0 36.5649 500.0005 500.0005)" id="224768">
            <path
              style={{
                stroke: 'none',
                strokeWidth: 1,
                strokeDasharray: 'none',
                strokeLinecap: 'butt',
                strokeDashoffset: 0,
                strokeLinejoin: 'miter',
                strokeMiterlimit: 4,
                fill: color || '#000',
                fillRule: 'nonzero',
                opacity: 1,
              }}
              vectorEffect="non-scaling-stroke"
              transform="translate(-12.4312, -12.3956)"
              d="M 24.8624 12.3701 C 24.8746 19.1963 19.3266 24.7668 12.4905 24.7911 C 5.63723 24.8146 0.0187006 19.2489 0.0000424918 12.417 C -0.0178044 5.59486 5.58856 -0.000809471 12.4426 8.78317e-8 C 19.2861 0.000809647 24.8503 5.54305 24.8624 12.3701 Z M 1.77743 12.3765 C 1.75715 18.2151 6.54662 23.0174 12.4085 23.0344 C 18.2493 23.0514 23.0696 18.296 23.0956 12.4915 C 23.1215 6.58253 18.3791 1.77941 12.4969 1.75836 C 6.5961 1.7365 1.79771 6.48943 1.77743 12.3765 Z"
            />
          </g>
          <g transform="matrix(51.9034 0 0 51.9034 499.9999 499.9999)" id="183409">
            <path
              style={{
                stroke: 'none',
                strokeWidth: 1,
                strokeDasharray: 'none',
                strokeLinecap: 'butt',
                strokeDashoffset: 0,
                strokeLinejoin: 'miter',
                strokeMiterlimit: 4,
                fill: color || '#000',
                fillRule: 'nonzero',
                opacity: 1,
              }}
              vectorEffect="non-scaling-stroke"
              transform="translate(-5.4274, -5.3947)"
              d="M 4.52742 6.28976 C 3.53935 6.28976 2.6397 6.293 1.74086 6.28895 C 1.06025 6.28571 0.629487 5.92627 0.640844 5.37901 C 0.65139 4.84632 1.06106 4.5063 1.71896 4.50225 C 2.63321 4.49659 3.54746 4.50064 4.52823 4.50064 C 4.52823 3.51459 4.52985 2.58603 4.52823 1.65746 C 4.52742 1.24944 4.66208 0.918336 5.04254 0.723232 C 5.62094 0.426933 6.27804 0.782329 6.3259 1.47531 C 6.38106 2.28001 6.37701 3.09119 6.35348 3.89832 C 6.3405 4.3541 6.45894 4.53949 6.9546 4.51197 C 7.70903 4.46906 8.46753 4.49335 9.2244 4.50468 C 9.85634 4.51359 10.2149 4.84713 10.2141 5.39601 C 10.2141 5.94408 9.84904 6.28247 9.2244 6.28895 C 8.43183 6.29786 7.63846 6.31 6.8467 6.28329 C 6.45732 6.27033 6.34861 6.41848 6.35754 6.78116 C 6.37538 7.51705 6.37052 8.25456 6.35916 8.99045 C 6.34699 9.78058 6.01195 10.1878 5.41408 10.1708 C 4.84217 10.1546 4.53147 9.74415 4.52904 8.99045 C 4.52579 8.1137 4.52904 7.23695 4.52904 6.29138 L 4.52742 6.28976 Z"
            />
          </g>
        </svg>
    </button>
  )
}

export default MoreBtn;
